// todo:type colors names
export default function getCustomColor(color: string) {
  return getComputedStyle(document.body).getPropertyValue(color);
}
